import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import store from "./store/index.ts";
import "./index.css";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { errorHandlingService } from "./services/errorHandlingService";
import { logout } from "./store/slices/authSlice";

errorHandlingService.setLogoutCallback(() => {
  store.dispatch(logout());
  window.location.href = '/login';
});

// Remove service worker registration for now since it's causing issues
// We'll set it up properly later with vite-plugin-pwa

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <App />
        </LocalizationProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
